import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import CAPTCHATurnStile from "../admin/childComponents/appComponents/CAPTCHATurnStile";
import InputFieldLogin from "../admin/childComponents/inputComponents/InputFieldLogin";
import SelectFieldLogin from "../admin/childComponents/inputComponents/SelectFieldLogin";

const Register02 = () => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const BUTTON_NAME = "Create An Account";

  const { otp } = useParams();
  const navigate = useNavigate("");
  const [reCaptcha, setReCaptcha] = useState(false);

  //Fetches all Form Data
  const [formData, setFormData] = useState({
    input: {
      otpToken: { otp }.otp,
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      password: null,
      repeatpassword: null,
      agree: null,
    },
    select: {
      sex: null,
      title: null,
    },
  });

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  // Reload Page
  const [reloadState, setReloadState] = useState({
    loading: BUTTON_NAME,
  });

  /* load the user email and phone number automatically */
  useEffect(() => {
    (async () => await tableLoad(formData.input.otpToken))();
  }, []);

  async function tableLoad(otp) {
    await axios.get(BASE_URL + "verifyotp/" + otp).then((res) => {
      // Gets the address of the backend server to be able to point the Images currectly
      if (res?.data?.status === 200) {
        setFormData((prev) => ({
          ...prev,
          email: res.data.email,
          phone: res.data.phone,
        }));
      } else {
        console.log(res.data.validation_error);
      }
    });
  }

  /* End of load the user email and phone number automatically */
  async function createAccount(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      loading: (
        <div>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      ),
    }));

    const datas = {
      otpToken: formData.input.otpToken,
      firstName: formData.input.firstName,
      lastName: formData.input.lastName,
      sex: formData.select.sex,
      title: formData.select.title,
      email: formData.input.email,
      phone: formData.input.phone,
      password: formData.input.password,
      repeatpassword: formData.input.repeatpassword,
      agree: formData.input.agree,
    };

    await axios.get("sanctum/csrf-cookie").then((response) => {
      try {
        axios.post(BASE_URL + "register/create", datas).then((res) => {
          if (res?.data?.status === 200) {
            console.log(res.data.message);

            swal("Success", res.data.message, "success");
            navigate("/login");
            setReloadState((prev) => ({
              ...prev,
              loading: BUTTON_NAME,
            }));
          } else {
            swal("Warning", res.data.message, "warning");
            setReloadState((prev) => ({
              ...prev,
              loading: BUTTON_NAME,
            }));
          }
        });
      } catch (error) {
        swal("Oops!", "Registration Failed", "error");
        setReloadState((prev) => ({
          ...prev,
          loading: BUTTON_NAME,
        }));
      }
    });
  }
  return (
    <>
      <h2 className="login-title">ADMIN REGISTRATION</h2>
      <div class="row">
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputFieldLogin
                label="fa fa-user"
                name="firstName"
                size="14"
                placeholder="Your first name"
                required="required"
                value={formData.input.firstName}
                type="text"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputFieldLogin
                label="fa fa-user"
                name="lastName"
                size="14"
                placeholder="Your last name"
                required="required"
                value={formData.input.lastName}
                type="text"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <SelectFieldLogin
                label="fa fa-user"
                name="sex"
                size="14"
                placeholder="Select a Gender"
                required="required"
                value={formData.select.sex}
                options={["male", "female"]}
                switchOptions={0}
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <SelectFieldLogin
                label="fa fa-user"
                name="title"
                size="14"
                placeholder="Select a Title"
                required="required"
                value={formData.select.title}
                options={["Miss", "Mrs", "Mr"]}
                switchOptions={0}
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputFieldLogin
                label="fa fa-envelope"
                name="email"
                size="14"
                placeholder="name@example.com"
                required="required"
                value={formData.input.email}
                type="email"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputFieldLogin
                label="fa fa-phone"
                name="phone"
                size="14"
                placeholder="Your Phone Number"
                required="required"
                value={formData.input.phone}
                type="number"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputFieldLogin
                label="fa fa-lock"
                name="password"
                size="14"
                placeholder="Create a password"
                required="required"
                value={formData.input.password}
                type="password"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputFieldLogin
                label="fa fa-lock"
                name="repeatpassword"
                size="14"
                placeholder="Confirm password"
                required="required"
                value={formData.input.repeatpassword}
                type="password"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div className="form-group">
            <div className="input-group-icon right">
              <InputFieldLogin
                label="fa fa-phone"
                name="otpToken"
                size="14"
                placeholder="Paste the OTP"
                required="required"
                value={formData.input.otpToken}
                type="number"
                onChange={updateFormData}
              />
            </div>
          </div>
        </div>
        <div className="form-group">
          <InputFieldLogin
            label="I agree the terms and policy"
            name="agree"
            required=""
            value={formData.input.agree}
            type="checkbox"
            checked={null}
            onChange={updateFormData}
          />
        </div>
        <div className="form-group">
          <CAPTCHATurnStile reCaptcha={reCaptcha} setReCaptcha={setReCaptcha} />
        </div>
        <div className="form-group">
          <button
            disabled={!reCaptcha}
            className="btn btn-primary btn-block"
            onClick={createAccount}
          >
            {reloadState.loading}
          </button>
        </div>
      </div>

      <div className="social-auth-hr">
        <span>Follow Us On</span>
      </div>
      <div className="text-center social-auth m-b-20">
        <Link className="btn btn-social-icon btn-twitter m-r-5" to="#">
          <i className="fa fa-twitter"></i>
        </Link>
        <Link className="btn btn-social-icon btn-facebook m-r-5" to="#">
          <i className="fa fa-facebook"></i>
        </Link>
        <Link className="btn btn-social-icon btn-google m-r-5" to="#">
          <i className="fa fa-google-plus"></i>
        </Link>
        <Link className="btn btn-social-icon btn-linkedin m-r-5" to="#">
          <i className="fa fa-linkedin"></i>
        </Link>
      </div>

      <div className="card-footer text-center py-3 d-flex justify-content-between">
        <Link className="small" to="/login">
          Have an account? Go to login
        </Link>
        <div className="small">
          <Link to="/forgotpassword01">Forgot password?</Link>
        </div>
      </div>
    </>
  );
};
export default Register02;
